export const refs = {
  header: document.querySelector('.header'),
  furnitureCategoryTitle: document.querySelector('.furniture-category__title'),
  furnitureCategoryList: document.querySelector('.furniture-category__list'),
  furnitureList: document.querySelector('.furniture-list'),
  loadMoreBtn: document.querySelector('.load-more-btn'),
  accordionContainer: document.querySelector('.accordion'),
  orderBackdrop: document.querySelector('.order-backdrop'),
  orderModalOverlay: document.querySelector('.order-modal-overlay'),
  productModal: document.querySelector('.product-modal'),
  productModalCloseBtn: document.querySelector('.product-modal__close'),
  loaderCategory: document.querySelector('.js-loader-category'),
  loaderFeedback: document.querySelector('.js-loader-feedback'),
};
